import React, { useEffect, useState } from "react";
import { getImageUrl } from "../utils/imageUtils";
import { getAbout } from "../api/client";

const About = ({ settings, lang }) => {
    const [history, setHistory] = useState([]);
    const [team, setTeam] = useState([]);
    const [loading, setLoading] = useState(true);

    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getAbout();
                setHistory(response.data.history || []);
                setTeam(response.data.team || []);
            } catch (error) {
                console.error("Failed to fetch about data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        document.title = getStatic("page_title_about", "إينوبريدج - عنا");
        document.description = getStatic("meta_description_about", "إينوبريدج - عنا");
        document.keyword = getStatic("meta_keyword_about", "إينوبريدج - عنا");
    }, [lang, settings]);

    return (
        <>
            <header className="py-5 bg-body header header1">
                <div className="layout-h"></div>
                <div className="container py-5 text-center">
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getStatic("about_title", "About InnoBridge")}
                    </h1>
                    <p className="lead mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getStatic("about_desc", "We are a global team...")}
                    </p>
                </div>
            </header>
            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row align-items-center gy-5">
                        <div className="col-lg-6" data-aos="fade-up">
                            <img src={getStatic("about_story_img") ? getImageUrl(getStatic("about_story_img"), 'imgWeb') : "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800"}
                                alt="Our Story" className="img-fluid rounded-custom shadow-lg" />
                        </div>
                        <div className="col-lg-6" data-aos="zoom-in">
                            <h2 className="fw-bold mb-4">{getStatic("about_story_title", "Our Story")}</h2>
                            <p className="mb-4">{getStatic("about_story_p1", "Founded in 2015...")}</p>
                            <p>{getStatic("about_story_p2", "We believe that true innovation...")}</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container py-4">

                    {/* Title */}
                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {getStatic("about_mission_title", "Mission & Vision")}
                        </h2>
                        <p className="text-muted fs-5">
                            {getStatic("about_mission_des", "Guiding principles that drive our success")}
                        </p>
                    </div>

                    <div className="row g-4 align-items-stretch">

                        {/* Mission */}
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="h-100 p-5 bg-card position-relative overflow-hidden">

                                <div className="mb-4 position-relative">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-4">
                                        <i className="ri-compass-3-line" style={{ fontSize: 50 }}></i>
                                    </div>
                                </div>

                                <h3 className="fw-bold mb-4">
                                    {getStatic("mission_title", "Our Mission")}
                                </h3>

                                <p className="mb-0">
                                    {getStatic(
                                        "mission_description",
                                        "To empower businesses with innovation and technology."
                                    )}
                                </p>
                            </div>
                        </div>

                        {/* Vision */}
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="h-100 p-5 bg-card position-relative overflow-hidden">

                                <div className="mb-4 position-relative">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-4">
                                        <i className="ri-eye-line" style={{ fontSize: 50 }}></i>
                                    </div>
                                </div>

                                <h3 className="fw-bold mb-4">
                                    {getStatic("vision_title", "Our Vision")}
                                </h3>

                                <p className="mb-0">
                                    {getStatic(
                                        "vision_description",
                                        "To become the world’s most trusted innovation partner."
                                    )}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="py-5 timeline-section bg-card">
                <div className="container">

                    {/* Header */}
                    <div className="section-title text-center mb-4" data-aos="zoom-in">
                        <h2>{getStatic("timeline_title", "Our history")}</h2>
                        <p className="text-muted">
                            {getStatic("timeline_desc", "Learn about our journey since the beginning.")}
                        </p>
                    </div>

                    <div className="timeline">

                        {history.length > 0 ? (
                            history.map((item, index) => (
                                <div
                                    className="timeline-item"
                                    key={item.id}
                                    data-aos={index % 2 === 0 ? "fade-up" : "zoom-in"}
                                >
                                    <div
                                        className="timeline-dot"
                                        style={{ background: "var(--primary)" }}
                                    >
                                        {item.data}
                                    </div>

                                    <div className="timeline-content bg-body mt-2">
                                        <p className="m-0">
                                            {lang === 'en' ? item.title_en : item.title_ar}
                                        </p>
                                    </div>

                                    <div className="timeline-content bg-body mt-2 col-11">
                                        <p className="m-0">
                                            {lang === 'en' ? item.desc_en : item.desc_ar}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">{lang === 'en' ? 'No history available' : 'لا يوجد تاريخ متاح'}</p>
                            </div>
                        )}
                    </div>

                </div>
            </section>
            <section className="py-5 bg-body">
                <div className="container">

                    <div className="text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold">
                            {getStatic("about_values_title", "Our Values")}
                        </h2>

                        <p className="text-muted">
                            {getStatic("about_values_desc", "Core values that guide our work.")}
                        </p>
                    </div>

                    <div className="row gy-4">

                        {/* Value 1 */}
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="card-custom bg-card h-100 text-center shadowP">
                                <div className="mb-3 text-primary">
                                    <i className="ri-service-line fs-1"></i>
                                </div>

                                <h4 className="fw-bold mb-3">
                                    {getStatic("about_val_integrity", "Integrity")}
                                </h4>

                                <p className="mb-0">
                                    {getStatic("about_val_integrity_desc", "We act with honesty.")}
                                </p>
                            </div>
                        </div>

                        {/* Value 2 */}
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="card-custom bg-card h-100 text-center shadowP">
                                <div className="mb-3 text-primary">
                                    <i className="ri-lightbulb-line fs-1"></i>
                                </div>

                                <h4 className="fw-bold mb-3">
                                    {getStatic("about_val_innovation", "Innovation")}
                                </h4>

                                <p className="mb-0">
                                    {getStatic("about_val_innovation_desc", "We innovate constantly.")}
                                </p>
                            </div>
                        </div>

                        {/* Value 3 */}
                        <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="card-custom bg-card h-100 text-center shadowP">
                                <div className="mb-3 text-primary">
                                    <i className="ri-group-line fs-1"></i>
                                </div>

                                <h4 className="fw-bold mb-3">
                                    {getStatic("about_val_collab", "Collaboration")}
                                </h4>

                                <p className="mb-0">
                                    {getStatic("about_val_collab_desc", "We work as one team.")}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="py-5 bg-card">
                <div className="container py-4">

                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">
                            {getStatic("team_title", "Meet Our Team")}
                        </h2>
                        <p className="text-muted fs-5">
                            {getStatic("team_desc", "The talented people behind our success")}
                        </p>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {team.length > 0 ? (
                            team.map((member, index) => (
                                <div
                                    className="col-lg-3 col-md-6"
                                    key={member.id}
                                    data-aos="fade-up"
                                    data-aos-delay={100 * (index + 1)}
                                >
                                    <div className="text-center h-100">

                                        <div className="mb-4 position-relative d-inline-block">
                                            <div
                                                className="position-relative overflow-hidden rounded-circle"
                                                style={{ width: 180, height: 180 }}
                                            >
                                                {member.img ? (
                                                    <img
                                                        src={getImageUrl(member.img, 'imgPro')}
                                                        alt={lang === 'en' ? member.name_en : member.name_ar}
                                                        className="w-100 h-100 object-fit-cover"
                                                    />
                                                ) : (
                                                    <div className="bg-primary bg-opacity-10 w-100 h-100 d-flex align-items-center justify-content-center">
                                                        <i className="ri-user-line" style={{ fontSize: 80 }}></i>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="position-absolute top-0 start-0 w-100 h-100 rounded-circle border border-3 border-primary opacity-25"></div>
                                        </div>

                                        <h5 className="fw-bold mb-2">{lang === 'en' ? member.name_en : member.name_ar}</h5>
                                        <p className="text-primary mb-3">{lang === 'en' ? member.job_en : member.job_ar}</p>

                                        <p className="text-muted small mb-3">
                                            {lang === 'en' ? member.desc_en : member.desc_ar}
                                        </p>

                                        <div className="d-flex gap-2 justify-content-center">
                                            {member.linkin && (
                                                <a href={member.linkin} target="_blank" rel="noopener noreferrer" className="btn-sm btn btn-outline-custom rounded-circle">
                                                    <i className="ri-linkedin-fill"></i>
                                                </a>
                                            )}
                                            {member.inst && (
                                                <a href={member.inst} target="_blank" rel="noopener noreferrer" className="btn-sm btn btn-outline-custom rounded-circle">
                                                    <i className="ri-instagram-line"></i>
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center py-5">
                                <p className="text-muted">{lang === 'en' ? 'No team members available' : 'لا يوجد أعضاء فريق متاحين'}</p>
                            </div>
                        )}

                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container py-4">
                    <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                        <h2 className="fw-bold display-5 mb-3">{getStatic("about_mission_title", "Mission & Vision")}</h2>
                        <p className="text-muted fs-5">{getStatic("about_mission_des", "Guiding principles...")}</p>
                    </div>
                    {/* Simplified Mission/Vision display */}
                    <div className="row g-4 align-items-stretch">
                        <div className="col-lg-6" data-aos="fade-up">
                            <div className="h-100 p-5 bg-card position-relative overflow-hidden">
                                <h3 className="fw-bold mb-4">{getStatic("mission_title", "Our Mission")}</h3>
                                <p>{getStatic("mission_description", "To empower businesses...")}</p>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="h-100 p-5 bg-card position-relative overflow-hidden">
                                <h3 className="fw-bold mb-4">{getStatic("vision_title", "Our Vision")}</h3>
                                <p>{getStatic("vision_description", "To be the world's most trusted partner...")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
